class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.nextUrl = this.dataset.nextUrl || "";
    this.sectionId = this.dataset.sectionId || "";
    this.autoLoadsRemaining = parseInt(this.dataset.autoLoads || "2", 10);
    this.grid = this.querySelector("ul.product-grid");
    this.sentinel = this.querySelector("[data-infinite-sentinel]");
    this.loadMoreBtn = this.querySelector("[data-infinite-load-more]");
    this.spinner = this.querySelector("[data-infinite-spinner]");
    this.loading = false;
    this.observer = null;

    if (!this.nextUrl || !this.grid) return;

    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener("click", () => this.loadNext());
    }
    this.startObserver();
  }

  startObserver() {
    if (!this.sentinel) return;
    if (this.autoLoadsRemaining <= 0) {
      this.showLoadMoreButton();
      return;
    }
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.loading) this.loadNext();
      },
      { rootMargin: "400px" },
    );
    this.observer.observe(this.sentinel);
  }

  async loadNext() {
    if (this.loading || !this.nextUrl) return;
    this.loading = true;
    this.spinner?.classList.remove("hidden");
    this.loadMoreBtn?.classList.add("hidden");

    const separator = this.nextUrl.includes("?") ? "&" : "?";
    const url = this.sectionId
      ? `${this.nextUrl}${separator}section_id=${this.sectionId}`
      : this.nextUrl;

    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, "text/html");

      const newGrid = doc.querySelector("ul.product-grid");
      if (newGrid) {
        const newItems = newGrid.querySelectorAll(":scope > li");
        newItems.forEach((li) => {
          li.classList.remove("scroll-trigger", "animate--slide-in");
          this.grid.appendChild(li);
        });
      }

      const fetchedScroller = doc.querySelector("infinite-scroll");
      this.nextUrl = fetchedScroller?.dataset.nextUrl || "";
      this.autoLoadsRemaining -= 1;
      this.afterLoad();
    } catch (e) {
      console.error("Infinite scroll fetch failed", e);
      this.observer?.disconnect();
      if (this.nextUrl) {
        this.sentinel?.classList.add("hidden");
        this.loadMoreBtn?.classList.remove("hidden");
      }
    } finally {
      this.loading = false;
      this.spinner?.classList.add("hidden");
    }
  }

  afterLoad() {
    if (!this.nextUrl) {
      this.observer?.disconnect();
      this.sentinel?.remove();
      this.loadMoreBtn?.remove();
      return;
    }
    if (this.autoLoadsRemaining <= 0) {
      this.observer?.disconnect();
      this.showLoadMoreButton();
    }
  }

  showLoadMoreButton() {
    this.sentinel?.classList.add("hidden");
    this.loadMoreBtn?.classList.remove("hidden");
  }
}

customElements.define("infinite-scroll", InfiniteScroll);
